
























import Vue from 'vue'
import { PropValidator } from 'vue/types/options'
import { IDevice, IVW } from '@/types/model'
import RadioIcon from '@/components/RadioIcon.vue'
import AliveIndicator from '@/components/AliveIndicator.vue'
import PreviewScreen from '@/components/PreviewScreen.vue'
import easyapi from '@/easyapi'
import mixins from 'vue-typed-mixins'
import { getVwTxColor, getVwTxColorWhenTxInVw } from '@/vw_algorithm'

export default Vue.extend({
  components: {
    PreviewScreen,
    RadioIcon,
    AliveIndicator,
  },
  model: {
    prop: 'chosen',
    event: 'chose'
  },
  props: {
    /** Currently chosen in this radio group. Use v-model to access this. */
    chosen: {
      type: Object
    } as PropValidator<IDevice|null>,
    device: {
      type: Object
    } as PropValidator<IDevice>,
    vw: {
      type: Object
    } as PropValidator<IVW>,
    /** For hint user this area is draggable */
    draggerBlinking: {
      type: Boolean
    }
  },
  data (): {
    dragging: boolean
  } {
    return {
      dragging: false
    }
  },
  computed: {
    thisDeviceIsChosen (): boolean { return this.device === this.chosen },
    mappedAreaColorStyle (): string {
      const clr = getVwTxColorWhenTxInVw(this.device.mac, this.vw)
      if (!clr) {return ''}
      return `background-color: ${clr.bg};border-color: ${clr.bd};`
    }
  },
  methods: {
    blinkLed () { easyapi.blinkLed(this, this.device) },
    openDeviceRenameDialog () { this.$router.push({ name: 'vwlst_details_txmap_rename', params: {mac: this.device.mac} }) },
    chooseThisDevice () { this.$emit('chose', this.device) }, // See the doc of v-model (v-model is a syntax sugar)
    dragStart (evt: DragEvent) {
      this.dragging = true
      evt.dataTransfer.setData('text/unusedThough', 'For Firefox, this is required.')
      this.$emit('dragStart', this.device)
    },
    drag (evt: DragEvent) { //
    },
    dragEnd (evt: DragEvent) {
      this.dragging = false
      this.$emit('dragEnd', this.device)
    },
    mouseEnter (evt: MouseEvent) {
      this.$emit('mouseEnter', this.device)
    },
    mouseLeave (evt: MouseEvent) {
      this.$emit('mouseLeave', this.device)
    },
  },
  mounted () {
    if (!this.vw) {
      console.error('[To Developer] :vw is required')
    }
  }
})
